import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { InboxCommonPayment } from 'pages/settings/ui/InboxCommonPayment/InboxCommonPayment'
import { useAddNumberFromAppContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppContext'

export const Payment = observer(() => {
  const {
    paymentStore,
    loading,
    selectAppAndNumbersStore,
    selectedNumbersCount,
    setVisibleUI,
    buyNumber,
  } = useAddNumberFromAppContext()

  useEffect(() => {
    setVisibleUI(true)

    return () => {
      setVisibleUI(false)
    }
  }, [])

  return (
    <InboxCommonPayment
      salesmsgNumbers={[]}
      appSelectedNumber={selectAppAndNumbersStore.selectedNumber}
      licensesRequired={selectedNumbersCount}
      stepLoading={loading}
      paymentStore={paymentStore}
      handleOnClick={() => buyNumber()}
      buttonText={'Buy number'}
    />
  )
})
